import { makeStyles } from '@mui/styles';
import {
  COLOR_GRAY_70,
  COLOR_PURPLE,
  COLOR_PINK,
  COLOR_GRAY_40,
  COLOR_WHITE,
  COLOR_PURPLE_HOVER,
} from 'styles/variables/colors';

export const useStyles = makeStyles((theme) => ({
  primaryColor: {
    color: '#7833FF',
  },
  section: {
    '& > div:first-child': {
      marginBottom: theme.spacing(6),
    },

    [theme.breakpoints.up('md')]: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-around',
    },
  },
  whiteButton: {
    padding: theme.spacing(1.5, 3),
    textTransform: 'none',
    borderRadius: 40,
  },
  image: {
    display: 'block',
    margin: '0 auto',
    maxWidth: '100%',
  },
  title: {
    margin: 0,
    color: COLOR_GRAY_70,
    fontSize: '2.125rem',
    fontStyle: 'normal',
    fontWeight: 400,
    marginBottom: '2rem',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  heroParagraph: {
    margin: 0,
    color: COLOR_GRAY_70,
    fontSize: '1.125rem',
    fontStyle: 'normal',
    fontWeight: 400,
    marginBottom: '1rem',
  },
  containerButtonHero: {
    marginTop: '2rem',
  },
  customersHero: {
    display: 'flex',
    alignItems: 'center',
    gap: 10,
    marginTop: 13,
    width: 268,
    justifyContent: 'center',
    '& span': {
      color: COLOR_GRAY_70,
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 400,
      lineHeight: '17px',
    },
  },
  scienceDesignTitle: {
    fontSize: '2rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '39px',
    color: COLOR_GRAY_70,
    textAlign: 'center',
    marginTop: 0,
    marginBottom: '3rem',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  cardScienceDesign: {
    width: 247,
    textAlign: 'center',
    display: 'flex',
    flexDirection: 'column',
    gap: 8,
    '& p': {
      fontSize: '0.875rem',
      fontStyle: 'normal',
      fontWeight: 700,
      lineHeight: '17px',
      color: COLOR_GRAY_70,
      margin: 0,
    },
    '& a': {
      color: COLOR_PURPLE,
      '&:hover': {
        color: COLOR_PURPLE_HOVER,
      },
    },
  },
  scienceDesignImage: {
    position: 'absolute',
    top: 66,
  },
  titleConfidentiality: {
    textAlign: 'center',
    fontSize: '1.875rem',
    fontStyle: 'normal',
    marginBottom: 32,
    position: 'relative',
    fontWeight: 400,
    color: COLOR_GRAY_70,
    margin: 0,
    '& b': {
      color: COLOR_PINK,
    },
  },
  paragraphGray: {
    color: COLOR_GRAY_70,
    fontSize: '1.25rem',
    fontStyle: 'normal',
    position: 'relative',
    fontWeight: 400,
    textAlign: 'center',
    maxWidth: 848,
    margin: '0 auto',
    marginTop: 10,
    marginBottom: 40,
  },
  buttonConfidentiality: {
    padding: theme.spacing(1.6, 3),
    border: `1px solid ${COLOR_GRAY_40}`,
    backgroundColor: 'transparent',
    fontStyle: 'normal',
    lineHeight: '22px',
    textTransform: 'none',
    color: COLOR_GRAY_70,
    borderRadius: 35,
    marginBottom: 12,
    '&:hover': {
      color: COLOR_PURPLE,
      border: `1px solid ${COLOR_PURPLE}`,
    },
  },
  confidentialityImage: {
    position: 'absolute',
    right: 0,
    top: 117,
  },
  descriptionProduct: {
    display: 'flex',
    justifyContent: 'space-between',
    position: 'relative',
  },
  presentationDesignImage: {
    position: 'absolute',
    left: -60,
    top: 109,
  },
  tag: {
    display: 'flex',
    padding: '5px 10px',
    gap: 10,
    borderRadius: 5,
    background: COLOR_WHITE,
    boxShadow: '0px 4px 4px 0px rgba(0, 0, 0, 0.25)',
    width: 'max-content',
    marginBottom: 16,
    fontWeight: 700,
    color: COLOR_GRAY_70,
  },
  titleDescriptionProduct: {
    fontSize: '1.875rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    color: COLOR_GRAY_70,
    marginBottom: '2rem',
    '& b': {
      color: COLOR_PURPLE,
    },
  },
  textDescription: {
    maxWidth: 538,
  },
  paragraphDescriptionProduct: {
    color: COLOR_GRAY_70,
    fontSize: '1rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '19px',
    margin: 0,
    marginBottom: 16,
  },
  presentationDesignImageCover: {
    position: 'absolute',
    right: 0,
    top: -47,
  },
  containerProductDescription: {
    maxWidth: 1066,
    margin: '0 auto',
  },
  biotechsImage: {
    position: 'absolute',
    left: 0,
  },
  presentationDesignImageInfographics: {
    position: 'absolute',
    right: 319,
    top: -47,
  },
  titleAbout: {
    fontSize: '1.875rem',
    fontStyle: 'normal',
    fontWeight: 400,
    lineHeight: '36px',
    color: COLOR_GRAY_70,
    textAlign: 'center',
    margin: 0,
    marginBottom: '2.5rem',
    '& b': {
      color: COLOR_PURPLE,
      fontWeight: 700,
    },
  },
  aboutText: {
    maxWidth: 534,
    '& p': {
      textAlign: 'left',
      fontSize: 16,
      marginBottom: 16,
    },
  },
  hiveImage: {
    position: 'absolute',
    left: 0,
  },
  accordionDetailsParagrath: {
    margin: 0,
    fontSize: '0.875rem',
    fontStyle: 'normal',
    fontWeight: 400,
    color: COLOR_GRAY_70,
  },
  moonIcon: {
    position: 'absolute',
    right: '7%',
    top: '19%',
    zIndex: 0,

    [theme.breakpoints.down(1212)]: {
      display: 'none',
    },
  },
}));
